import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginPayload } from "@src/interfaces/auth.interface";
import { profileApi } from "@entities/profile";
import { clearAuthData,getUUID, setAccessToken, setRefreshToken } from "@shared/lib/utils";
import { API, setReduxAccessToken } from "../authSlice";
import { hideModals } from "../layoutSlice";
import { mergeFavorites, offersApi } from "../offersApi";
import { LoginResponse } from "../types";

export const loginUser = createAsyncThunk<LoginResponse, any, { rejectValue: { message: string } }>(
    "auth/login",
    async (payload: LoginPayload, thunkAPI) => {
        try {
            const response = await fetch(`${API}/v1/users/authentication`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-DEVICE-UUID": getUUID()
                },
                body: JSON.stringify(payload)
            });

            let data: LoginResponse = await response.json();

            if (response.status === 200) {
                const token = data?.data?.accessToken;
                const refreshToken = data?.data?.refreshToken;

                if (!token) {
                    throw new Error("No token come from server");
                }
                setAccessToken(token);
                setRefreshToken(refreshToken);

                thunkAPI.dispatch(hideModals());

                const profileQuery = profileApi.endpoints.getProfile.initiate({
                    accessToken: token
                });

                const res: any = await thunkAPI.dispatch(profileQuery);
                const userData = res.data;

                localStorage.setItem("user", JSON.stringify(userData));

                thunkAPI.dispatch(setReduxAccessToken(token));
                await thunkAPI.dispatch(mergeFavorites());
                thunkAPI.dispatch(offersApi.util.invalidateTags(["Favorites"]));
                return {
                    ...data,
                    user: userData
                };
            } else {
                clearAuthData();
                if (response.status === 400) {
                    return thunkAPI.rejectWithValue({
                        message: data.message || "Неверный логин или пароль"
                    });
                } else {
                    return thunkAPI.rejectWithValue({
                        message: data.message || "Сервер не отвечает"
                    });
                }
            }
        } catch (e: any) {
            return thunkAPI.rejectWithValue({
                message: e.response.data || "Something went wrong"
            });
        }
    }
);